import { createContext, useContext, useEffect } from 'react';
import { IconChevronRight } from '../components/icons';

/*
 * Хлебные крошки (элемент 3.64, решение Ильи 25.09.2026 — вернуть везде).
 *
 * Путь собирается сам: каждый экран стопки называет себя заголовком своей
 * шапки (`useCrumbTitle`, `PageHeader` делает это сам), а хост стопки
 * (`StackHost`) отдаёт каждому слою путь из заголовков тех, кто под ним.
 * Щелчок по звену снимает стопку до этого экрана тем же путём, что и
 * «назад». Вручную путь не пишется нигде: руками написанные крошки
 * разъезжались с тем, что на самом деле лежит в стопке.
 *
 * На телефоне крошек нет: там экран стопки со стрелкой «назад» в шапке, и
 * строка пути над заголовком съедала бы неподвижную шапку.
 */

export type Crumb = { title: string; onClick: () => void };

type CrumbSlot = { trail: Crumb[]; set: (title: string) => void };

export const CrumbContext = createContext<CrumbSlot | null>(null);

/** Экран называет себя в пути: заголовок его шапки. */
export function useCrumbTitle(title: string) {
  const slot = useContext(CrumbContext);
  const set = slot?.set;
  useEffect(() => {
    if (set && title) set(title);
  }, [set, title]);
}

/** То же, что `useCrumbTitle`, разметкой: для экранов со своей шапкой. */
export function CrumbTitle({ title }: { title: string }) {
  useCrumbTitle(title);
  return null;
}

/** Путь до этого экрана: звенья под ним, без него самого. */
export function Crumbs() {
  const trail = useContext(CrumbContext)?.trail ?? [];
  // На телефоне строку прячет стиль (3.64): хук ширины здесь не нужен.
  if (!trail.length) return null;
  return (
    <nav className="crumbs" aria-label="Путь">
      {trail.map((c, i) => (
        <span className="crumb" key={`${i}:${c.title}`}>
          {i > 0 && <IconChevronRight />}
          <button className="btn link sm" type="button" onClick={c.onClick}>
            {c.title}
          </button>
        </span>
      ))}
    </nav>
  );
}
